import React, { useState } from 'react';
import PDFTemplateManager from '../components/PDFTemplateManager';
import EmailTemplateManager from '../components/EmailTemplateManager';

type TabType = 'pdf' | 'email';

const Templates: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('pdf');

  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-4">Template Management</h1>
        
        {/* Tab Navigation */}
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('pdf')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'pdf'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              PDF Templates
            </button>
            <button
              onClick={() => setActiveTab('email')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'email'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Email Templates
            </button>
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'pdf' && <PDFTemplateManager />}
        {activeTab === 'email' && <EmailTemplateManager />}
      </div>
    </div>
  );
};

export default Templates;
